import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './page-intro.component.scss';
var PageIntro = /** @class */ (function (_super) {
    tslib_1.__extends(PageIntro, _super);
    function PageIntro(element) {
        return _super.call(this, element) || this;
    }
    PageIntro.prototype.init = function () { };
    PageIntro.prototype.bindEvents = function () { };
    return PageIntro;
}(Base));
export { PageIntro };



//////////////////
// WEBPACK FOOTER
// ./components/page-intro/page-intro.component.ts
// module id = 429
// module chunks = 0